import { SITE_VARIABLES } from '../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../common/store/store.types';

interface StylesObject {
  readMoreContainerStyle: { [key: string]: any };
  buttonWrapperStyle: { [key: string]: any };
  blackStripStyle: { [key: string]: any };
  readMoreButtonStyle: { [key: string]: any };
  readMoreTextStyle: { [key: string]: any };
  arrowUpStyle: { [key: string]: any };
}

const readMoreContainer = {
  width: '100%',
  pointerEvents: 'none',
  display: 'flex',
  mainPlayer: {
    position: 'absolute',
    height: '100%',
    alignItems: 'center',
    flexDirection: 'row-reverse',
  },
  miniPlayer: {
    justifyContent: 'center',
  },
};

const buttonWrapper = {
  position: 'absolute',
  borderRadius: '30px 0px 0px 30px',
  display: 'flex',
  background: SITE_VARIABLES.COLORS.WHITE,
  opacity: '1',
  transition: 'all 0.5s ease-in-out',
  alignItems: 'center',
  flexDirection: 'row-reverse',
  mediumButton: {
    width: '77px',
    height: '40px',
  },
  largeButton: {
    width: '95px',
    height: '50px',
  },
  extraLargeButton: {
    width: '99px',
    height: '54px',
  },
  hide: {
    opacity: '0',
    pointerEvents: 'none',
  },
  miniPlayer: {
    zIndex: '2',
  },
};

const blackStrip = {
  position: 'absolute',
  width: '100%',
  height: '6px',
  background: SITE_VARIABLES.COLORS.BLACK,
  hide: {
    display: 'none',
  },
};

const readMoreButton = {
  display: 'flex',
  justifyContent: 'center',
  zIndex: '2',
  cursor: 'pointer',
  pointerEvents: 'all',
  opacity: 1,
  transition: 'all 0.5s ease-in-out',
  alignItems: 'center',
  mainPlayer: {
    background: '#333333',
    borderRadius: '30px 0px 0px 30px',
    mediumButton: {
      width: '75px',
      height: '36px',
    },
    largeButton: {
      width: '93px',
      height: '46px',
    },
    extraLargeButton: {
      width: '97px',
      height: '50px',
    },
    onHover: {
      background: 'linear-gradient(0deg, #737373, #737373), #333333',
    },
  },
  miniPlayer: {
    background: '#4C4C4C',
    borderRadius: '60px',
    width: '98px',
    height: '28px',
    transform: 'translateY(0)',
    extraSmallButton: {
      marginTop: '-11px',
    },
    smallButton: {
      marginTop: '-8px',
    },
    mediumButton: {
      width: '106px',
      height: '32px',
      marginTop: '-8px',
    },
    largeButton: {
      width: '130px',
      height: '36px',
      marginTop: '-16px',
    },
    extraLargeButton: {
      width: '165px',
      height: '45px',
      marginTop: '-23px',
    },
    hideButton: {
      transform: 'translateY(10px)',
      opacity: 0,
      pointerEvents: 'none',
    },
    onHover: {
      background: '#737373',
    },
  },
};

const readMoreText = {
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontWeight: '700',
  color: SITE_VARIABLES.COLORS.WHITE,
  display: 'block',
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  alignSelf: 'center',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  mainPlayer: {
    padding: '10px',
    textAlign: 'center',
    marginRight: '10px',
    medium: {
      lineHeight: '11px',
    },
    large: {
      fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_SMALL,
      lineHeight: '13px',
    },
    extraLarge: {
      fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
      lineHeight: '110%',
      marginRight: '8px',
    },
  },
  miniPlayer: {
    smallAndExtraSmall: {
      lineHeight: '12px',
    },
    extraLarge: {
      fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_SMALL,
    },
  },
  onHover: {
    cursor: 'pointer',
  },
};

const arrowUp = {
  position: 'absolute',
  zIndex: '2',
  right: '12px',
  mediumButton: {
    right: '10px',
  },
};

export const getReadMoreStyleObject = (anchorStatusActive: boolean, videoLoading: boolean, adPlaying: boolean, buttonHovered: boolean, playerSize: PlayerSizesTypes, mobilePlayerMode: boolean): StylesObject => {
  const extraSmallButton = playerSize === 'extraSmall';
  const smallButton = playerSize === 'small';
  const mediumButton = playerSize === 'medium';
  const largeButton = playerSize === 'large';
  const extraLargeButton = playerSize === 'extraLarge';
  const hideButton = adPlaying || videoLoading;

  return {
    readMoreContainerStyle: [
      readMoreContainer,
      !anchorStatusActive && readMoreContainer.mainPlayer,
      anchorStatusActive && readMoreContainer.miniPlayer,
    ],
    buttonWrapperStyle: [
      anchorStatusActive && buttonWrapper.miniPlayer,

      !anchorStatusActive && buttonWrapper,
      !anchorStatusActive && mediumButton && buttonWrapper.mediumButton,
      !anchorStatusActive && largeButton && buttonWrapper.largeButton,
      !anchorStatusActive && extraLargeButton && buttonWrapper.extraLargeButton,
      !anchorStatusActive && (hideButton || smallButton || extraSmallButton) && buttonWrapper.hide,
    ],
    blackStripStyle: [
      blackStrip,
      hideButton && blackStrip.hide,
    ],
    readMoreButtonStyle: [
      readMoreButton,

      anchorStatusActive && readMoreButton.miniPlayer,
      anchorStatusActive && extraSmallButton && readMoreButton.miniPlayer.extraSmallButton,
      anchorStatusActive && smallButton && readMoreButton.miniPlayer.smallButton,
      anchorStatusActive && mediumButton && readMoreButton.miniPlayer.mediumButton,
      anchorStatusActive && largeButton && readMoreButton.miniPlayer.largeButton,
      anchorStatusActive && extraLargeButton && readMoreButton.miniPlayer.extraLargeButton,
      anchorStatusActive && buttonHovered && readMoreButton.miniPlayer.onHover,
      anchorStatusActive && hideButton && readMoreButton.miniPlayer.hideButton,

      !anchorStatusActive && readMoreButton.mainPlayer,
      !anchorStatusActive && mediumButton && readMoreButton.mainPlayer.mediumButton,
      !anchorStatusActive && largeButton && readMoreButton.mainPlayer.largeButton,
      !anchorStatusActive && extraLargeButton && readMoreButton.mainPlayer.extraLargeButton,
      !anchorStatusActive && buttonHovered && readMoreButton.mainPlayer.onHover,
    ],
    readMoreTextStyle: [
      readMoreText,

      anchorStatusActive && (extraSmallButton || smallButton) && readMoreText.miniPlayer.smallAndExtraSmall,
      anchorStatusActive && extraLargeButton && readMoreText.miniPlayer.extraLarge,

      !anchorStatusActive && readMoreText.mainPlayer,
      !anchorStatusActive && mediumButton && readMoreText.mainPlayer.medium,
      !anchorStatusActive && largeButton && readMoreText.mainPlayer.large,
      !anchorStatusActive && extraLargeButton && readMoreText.mainPlayer.extraLarge,

      (mobilePlayerMode || buttonHovered) && readMoreText.onHover,
    ],
    arrowUpStyle: [
      arrowUp,
      mediumButton && arrowUp.mediumButton,
    ],
  };
};
